import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../../../../utils/common'
import { FilesPreviewGallery } from '../../../../../FilesPreviewGallery'
import { toPhotoPreviewFiles } from '../../../../RentalPortalPhotoGallery'
import { RentalPortalListingProfilePhotoEditorModal } from '../../../RentalPortalListingProfilePhotoEditorModal'
import {
  useListingProfileContext,
  useListingProfilePhotoEditorOpener,
} from '../../RentalPortalListingProfile.hooks'

import {
  QA_NAME_LISTING_PHOTO_MOSAIC,
  QA_NAME_LISTING_PHOTO_MOSAIC_LEAD,
} from './RentalPortalListingPhotoMosaic.constants'
import { useListingPhotoMosaic } from './RentalPortalListingPhotoMosaic.hooks'
import {
  getHasListingMosaicPhotos,
  getListingMosaicCells,
  toListingMosaicPhotos,
} from './RentalPortalListingPhotoMosaic.utils'
import { RentalPortalListingPhotoMosaicCell } from './RentalPortalListingPhotoMosaicCell'
import { RentalPortalListingPhotoMosaicEmpty } from './RentalPortalListingPhotoMosaicEmpty'
import { RentalPortalListingPhotoMosaicSkeleton } from './RentalPortalListingPhotoMosaicSkeleton'
import { RentalPortalListingPhotoMosaicTile } from './RentalPortalListingPhotoMosaicTile'

import * as styles from './RentalPortalListingPhotoMosaic.module.css'

function RentalPortalListingPhotoMosaic() {
  const { t } = useTranslation()

  const { isInitiated, listingData } = useListingProfileContext()

  const {
    canEditPhotos,
    handleOpenPhotoEditor,
    isPhotoEditorOpen,
    photoEditorProps,
  } = useListingProfilePhotoEditorOpener()

  const photos = toListingMosaicPhotos(listingData?.photos)

  const {
    activeFileIndex,
    activeLeadIndex,
    handleClickLead,
    handleClickMore,
    handleClickThumbnail,
    handleCloseFilePreview,
    previewPhotos,
  } = useListingPhotoMosaic({ photos })

  return (
    <>
      <div
        {...getQaSelector({ value: QA_NAME_LISTING_PHOTO_MOSAIC })}
        className={styles.RentalPortalListingPhotoMosaic}
      >
        {!isInitiated ? (
          <RentalPortalListingPhotoMosaicSkeleton />
        ) : getHasListingMosaicPhotos(photos) ? (
          <div className={styles.mosaic}>
            <RentalPortalListingPhotoMosaicTile
              isLead
              className={styles.hero}
              photo={photos[activeLeadIndex]}
              qaName={QA_NAME_LISTING_PHOTO_MOSAIC_LEAD}
              tooltip={t('RentalPortal.ListingPhotoOpenKey')}
              onClick={handleClickLead}
            />
            <div className={styles.grid}>
              {getListingMosaicCells({
                hasAddTile: canEditPhotos,
                leadIndex: activeLeadIndex,
                photos,
              }).map(cell => (
                <RentalPortalListingPhotoMosaicCell
                  cell={cell}
                  key={cell.id}
                  onAdd={handleOpenPhotoEditor}
                  onClickMore={handleClickMore}
                  onClickThumbnail={handleClickThumbnail}
                />
              ))}
            </div>
          </div>
        ) : (
          <RentalPortalListingPhotoMosaicEmpty
            canAdd={canEditPhotos}
            onAdd={handleOpenPhotoEditor}
          />
        )}
      </div>

      <FilesPreviewGallery
        files={toPhotoPreviewFiles(previewPhotos)}
        initActive={activeFileIndex}
        onClose={handleCloseFilePreview}
      />

      {isPhotoEditorOpen ? (
        <RentalPortalListingProfilePhotoEditorModal {...photoEditorProps} />
      ) : null}
    </>
  )
}

export default RentalPortalListingPhotoMosaic
